// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import {DropdownButton, MenuItem} from 'ui'
import { useCurrentUser } from 'hooks/users/queries';

function CollabDropdown({ 
  collaborator, 
  role, 
  myRole, 
  newCollaborator,
  removeCollaborator,
  updateCollaborator,
  isRemoving,
  isUpdating
}) {
  const { data: currentUser } = useCurrentUser();
  const isMe = currentUser && collaborator && currentUser.id === collaborator.id;

  const getMenuItems = () => {
    const edit = role === 'edit';
    const canEditProject = myRole === 'edit';
    const editAndViewItems = [
      <MenuItem
        eventKey="1"
        key="edit"
        active={edit}
        disabled={isUpdating}
        onClick={(e)=>{updateCollaborator('edit')}}
      >
          Can edit
      </MenuItem>,
      <MenuItem
        eventKey="2"
        key="view_only"
        active={!edit}
        disabled={isUpdating}
        onClick={(e)=>{updateCollaborator('view_only')}}
      >
        Can view
      </MenuItem>,
    ];

    if (newCollaborator) return editAndViewItems;

    const editItems = canEditProject && !isMe ?
      [...editAndViewItems, <MenuItem key="divider" divider />] : [];

    return [
      ...editItems,
      <MenuItem
        eventKey="4"
        key="remove"
        disabled={isRemoving}
        onClick={removeCollaborator}
      >
        {isRemoving ? "Removing..." : (!isMe ? "Remove" : "Leave Project")}
      </MenuItem>
    ]
  };

  const edit = role === 'edit';
  const menuItems = getMenuItems();
  const dropDownAppears = myRole === 'edit' || isMe || newCollaborator;
  const roleText = edit ? "Can edit" : "Can view";

  if (newCollaborator) {
      return <div>
        <DropdownButton
            variant="white"
            id="new-collab-dropdown"
            title={roleText}
            disabled={isUpdating}
        >
          {menuItems}
        </DropdownButton>
      </div>
  } else {
    return <div>
      <span>{roleText}</span>
      {dropDownAppears &&
        <DropdownButton
            variant="link"
            size="large"
            id="collab-dropdown"
            style={{margin: "0 0px 4px 5px", padding: 0}}
            title=''
            disabled={isRemoving || isUpdating}
          >
          {menuItems}
        </DropdownButton>
      }
    </div>
  }
}

export default CollabDropdown;
